// React:
import React from "react";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
// Redux Toolkit Actions & State:
import {
  subReportsModalCloseAction,
  subReportsModal,
} from "../subReportsModalSlice";
// MUI Components:
import { Modal, Box, useTheme } from "@mui/material";
// MUI Styles:,
import { makeStyles } from "@mui/styles";
import SubReportsModalTabel from "../sub-reports-modal-table/SubReportsModalTabel";

const useStyles = makeStyles((theme) => ({
  backdropStyle: {
    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
      backdropFilter: "blur(2px)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
  modalContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.90)",
    color: theme.palette.text.secondary,
    borderRadius: "8px",
    "&:focus": {
      outline: "none",
    },
  },
}));

const ResponsiveSubReportsModal = () => {
  const classes = useStyles();

  const theme=useTheme()

  const dispatch = useAppDispatch();

  const { openModal } = useAppSelector(subReportsModal);

  return (
    <Modal
      open={openModal}
      onClose={() => dispatch(subReportsModalCloseAction())}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1300,
        "&:focus": {
          outline: "none",
        },
        [theme.breakpoints.up("sm")]: {
          display: "none",
        },
      }}
      className={classes.backdropStyle}
    >
      <Box
        sx={{
          width: "80%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          "&:focus-visible": {
            outline: "none",
          },
        }}
      >
        <SubReportsModalTabel />
      </Box>
    </Modal>
  );
};

export default ResponsiveSubReportsModal;
